export function safeParseJSON(jsonString, defaultValue) {
  try {
    return JSON.parse(jsonString);
  } catch (ex) {
    return defaultValue || null;
  }
}
